import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { PortalCard } from "./PortalCard";
import { Content, Header, PageContainer } from "../Drawer/PageContainer";
import PortalForm from "./PortalForm";
import { getPortals } from "../../API/Portal/Portal";
import Loader from "../Shared/Loader/loader";
import { MsalContext } from "@azure/msal-react";
import { CheckForInternalUser } from "../Helpers/miscellaneous";
import Scrollable from "../Shared/Edit/Scrollable";
import Upgarde from "../Shared/Subscription/Upgrade";
import ServerError from "../Shared/Error/ServerError";
import { withTranslation } from "react-i18next";
import { propogateChangeToRealtimeIframe } from "../Helpers/Runtime/runtime";
import "./Portal.css";
class Portal extends Component {
    static contextType = MsalContext

    constructor(props) {
        super(props);
        this.state = {
            ShowCreatePortalPopup: false,
            showUpgradeDailog: false,
            loading: true,
            isInternalUser: false,
            Portals: [],
            cloneId: "",
        };
    }

    componentDidMount = async () => {
        try {
            await this.getPortal();
        } catch (e) {
            this.setState({ showServerError: true, errorMessage: "Something went wrong while fetching portals." })
        }
    };

    render() {
        if (this.state.redirect) {
            return (
                <Navigate
                    to={`/${this.props.organization.orgName}/${this.props.project.name}/Portals/${this.state.selectedPortalName}/General`}
                />
            );
        }

        if (this.state.loading) {
            return <Loader />;
        }

        if (this.state.serverError) {
            return (
                <ServerError
                    error={this.state.errorMessage} />
            )
        }
        const { t } = this.props;
        return (
            <PageContainer>
                <div className="chngBtn">
                    <Header
                        header={t("header.title")}
                        actionText={t("header.buttons.add_portal_button_label")}
                        actionClicked={() => this.toggleCreatePortalDialog(false)}
                        showAction={true}
                        showHelpCenter={(this.state.isInternalUser && this.props.project.developerMode) ? true : false}
                        user={this.props.user}
                        helpCenterFor={"Portals"}
                    ></Header>
                </div>
                <Content>
                    {
                        this.state.showUpgradeDailog &&
                        <Upgarde
                            organization={this.props.organization}
                            Headline={'Need to build more <br/>Super App portals? '}
                            toggleDialog={this.toggleUpgradeDailog}
                            Type={'Pro'}
                        />
                    }
                    {this.state.ShowCreatePortalPopup === true && (
                        <PortalForm
                            organization={this.props.organization}
                            project={this.props.project}
                            Portals={this.state.Portals}
                            cloneId={this.state.cloneId}
                            viewMode={false}
                            modal={true}
                            useSuspense={false}
                            onCancel={this.toggleCreatePortalDialog}
                            onClose={this.addPortal}
                        />
                    )}
                    <Scrollable>
                        <div className="p-2 mt-2">
                            {/* Web Portals Section */}
                            <div className="mb-4">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fas fa-desktop me-2"></i>
                                    <h5 className="mb-0 portal-section-header">{t("portal_sections.web_portals")}</h5>
                                </div>
                                <div className="row ps-1">
                                    {this.state.Portals.filter(portal => !portal.isMobilePortal).map((portal) => (
                                        <div key={portal._id} className="col-md-3 mb-3">
                                            <PortalCard
                                                portal={portal}
                                                project={this.props.project}
                                                goToPortal={this.goToPortal}
                                                clone={this.clone}
                                                isMobile={false}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Mobile Portals Section */}
                            <div className="mb-4">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fas fa-mobile-alt me-2"></i>
                                    <h5 className="mb-0 portal-section-header">{t("portal_sections.mobile_portals")}</h5>
                                </div>
                                <div className="row ps-1">
                                    {this.state.Portals.filter(portal => portal.isMobilePortal).map((portal) => (
                                        <div key={portal._id} className="col-md-3 mb-3">
                                            <PortalCard
                                                portal={portal}
                                                project={this.props.project}
                                                goToPortal={this.goToPortal}
                                                clone={this.clone}
                                                isMobile={true}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Scrollable>
                </Content>
            </PageContainer>
        );
    }

    goToPortal = (portal) => {
        if (this.props.isAccessedFromWorkspace) {
            this.props.selectPortal(portal);
            propogateChangeToRealtimeIframe(this.props.organization._id, this.props.project._id, "portalSelected", portal);
        } else {
            this.setState({
                redirect: true,
                selectedPortalName: portal.portalName,
            });
        }
    };

    getPortal = async () => {
        let result = await getPortals(this.props.project._id);
        result = result.sort((a, b) => a.order - b.order);
        let isInternalUser = CheckForInternalUser(this.props.user.email)
        this.setState({
            isInternalUser: isInternalUser,
            Portals: result,
            loading: false,
        });
    };

    toggleCreatePortalDialog = (showUpgradeDailog) => {
        this.setState({
            showUpgradeDailog: showUpgradeDailog,
            ShowCreatePortalPopup: !this.state.ShowCreatePortalPopup,
            cloneId: "",
        });
    };

    toggleUpgradeDailog = () => {
        this.setState({
            showUpgradeDailog: !this.state.showUpgradeDailog
        })
    }

    addPortal = (portal) => {
        let data = this.state.Portals;
        data.push(portal);

        if (portal.hasMobilePortal) {
            let mobilePortal = {
                ...portal,
                isMobilePortal: true,
            }
            data.push(mobilePortal);
        }
        this.setState({
            ShowCreatePortalPopup: false,
            cloneId: "",
            Portals: data,
        });
    };

    clone = (properties) => {
        this.setState({
            ShowCreatePortalPopup: true,
            cloneId: properties.id,
        });
    };
}

export default withTranslation([
    "portal/common",
], {
    withRef: true,
})(Portal);